import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=e3df7768&scoped=true&lang=pug"
import script from "./BaseVideo.vue?vue&type=script&lang=ts"
export * from "./BaseVideo.vue?vue&type=script&lang=ts"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=e3df7768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3df7768",
  null
  
)

export default component.exports